/**
 * @generated SignedSource<<cacdf401212f48f769fbd8c7d24356be>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "code" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "organization" | "organization_status_update" | "page" | "plan" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "risk" | "schema" | "slide" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "video" | "whiteboard" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchMercuryFocusAreaUpdate_AtlassianSearchPage$data = {
  readonly __typename: string;
  readonly description: string;
  readonly focusArea?: {
    readonly name: string;
  } | null;
  readonly id: string;
  readonly lastModifiedDate?: string | null;
  readonly type: SearchResultType;
  readonly url: string;
  readonly " $fragmentType": "searchMercuryFocusAreaUpdate_AtlassianSearchPage";
};
export type searchMercuryFocusAreaUpdate_AtlassianSearchPage$key = {
  readonly " $data"?: searchMercuryFocusAreaUpdate_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchMercuryFocusAreaUpdate_AtlassianSearchPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "searchMercuryFocusAreaUpdate_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "description"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "ScalarField",
      "name": "url"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "lastModifiedDate"
        },
        {
          "concreteType": "MercuryFocusArea",
          "kind": "LinkedField",
          "name": "focusArea",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "name"
            }
          ]
        }
      ],
      "type": "SearchResultMercuryFocusAreaStatusUpdate"
    }
  ],
  "type": "SearchResult",
  "abstractKey": "__isSearchResult"
};

(node as any).hash = "4bedbd663322481df5ab3989c8b87c7c";

export default node;
